import React, { useState, useEffect } from "react";

// components
import Table from "components/Table/TableUi";
import Modal from "components/Modal/Modal";
import GridItem from "components/Grid/GridItem";
import GridContainer from "components/Grid/GridContainer";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import {instance as API} from "utils/API";
import PARAMS from "utils/PARAMS";
import { validateFields, showSnack } from 'utils/helperFunctions';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Loader from 'react-loader-spinner';
import Actions from "components/Actions/Actions";

// Core
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';

// Icons
import AddIcon from '@material-ui/icons/Add';
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import SearchIcon from '@material-ui/icons/Search';

export default function Entidades() {
  const [entidades, setEntidades] = useState([]);
  const [tableHead, setTableHead] = useState([
    {id: "nombre", numeric: false, disablePadding: true, label: 'Nombre'},
    {id: "email", numeric: false, disablePadding: true, label: 'Email'},
    {id: "telefono", numeric: false, disablePadding: true, label: 'Teléfono'},
    {id: "acciones", numeric: false, disablePadding: true, label: 'Acciones'},
  ]);

  function createData(nombre, email, telefono, acciones) {
    return { nombre, email, telefono, acciones };
  }

  const [isLoad, setIsLoad] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [toSeach, setToSearch] = React.useState(null);
  const [entidad_id, setEntidadId] = React.useState('');
  const [entidad_name, setEntidadName] = React.useState('');
  const [entidad_email, setEntidadEmail] = React.useState('');
  const [entidad_phone, setEntidadPhone] = React.useState('');

  const [open, setOpen] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const handleClickOpen = () => {
    clearForm();
    setOpen(true);
  };
  const handleClickOpenEdit = () => {
    setOpenEdit(true);
  };
  const handleClickOpenConfirm = (id) => {
    setOpenConfirm(true);
    setEntidadId(id);
  };
  const handleClose = () => {
    setOpen(false);
    setOpenEdit(false);
    setOpenConfirm(false);
  };

  const styles = {
    cardCategoryWhite: {
      "&,& a,& a:hover,& a:focus": {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
      },
      "& a,& a:hover,& a:focus": {
        color: "#FFFFFF"
      }
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none",
      "& small": {
        color: "#777",
        fontSize: "65%",
        fontWeight: "400",
        lineHeight: "1"
      }
    },
    root: {
      width: '100%',
    },
  };
  const useStyles = makeStyles(styles);

  useEffect(() => {
    getEntidades();
  }, []);

  async function getEntidades() {
    setIsLoad(false);
    await API.post("entidades/index", {
      findBy: toSeach
    })
    .then(res => {
      if (res.data.length > 0) {
        const arrayEntidades = [];
        res.data.forEach(entidad => {
          let aux = createData(
            entidad["nombre"],
            entidad["email"],
            entidad['telefono'],
            (<div className={classes.root}>
              <Actions
                edit={true}
                onEdit={() => loadEdit(
                  entidad['id'],
                  entidad['nombre'],
                  entidad['email'],
                  entidad['telefono']
                )}
                del={true}
                onDelete={() => handleClickOpenConfirm(entidad['id'])}
              />
            </div>)
          );

          arrayEntidades.push(aux);
        });
        setEntidades(arrayEntidades);
        setIsLoad(true);
      }
    })
    .catch(err => {
      console.log(err);
      showSnack('warning', 'Se ha producido un error en la carga de entidades')
    });
  }

  function formEntidades(){
    return(<>
      <GridItem xs={6} sm={6} md={6}>
        <TextField
          label="Nombre"
          defaultValue={entidad_name}
          onChange={event => {
            const { value } = event.target;
            setEntidadName(value);
          }}
          error={(error && entidad_name == '') ? true : false}
        />
      </GridItem>
      <GridItem xs={6} sm={6} md={6}>
        <TextField
          label="Email"
          defaultValue={entidad_email}
          onChange={event => {
            const { value } = event.target;
            setEntidadEmail(value);
          }}
          error={(error && entidad_email == '') ? true : false}
        />
      </GridItem>
      <GridItem xs={6} sm={6} md={6} style={{ marginTop: "10px" }}>
        <TextField
          label="Teléfono"
          inputProps={{ pattern: "[a-z]" }}
          defaultValue={entidad_phone}
          onChange={event => {
            const { value } = event.target;
            setEntidadPhone(value);
          }}
          inputProps={{ maxLength: 9 }}
          error={(error && entidad_phone == '') ? true : false}
        />
      </GridItem>
    </>);
  }

  async function createEntidad(){
    if (!isProcessing) {
      var validate_fields = new Map([['nombre', entidad_name], ['email', entidad_email], ['teléfono', entidad_email]]);
      var validate = validateFields(validate_fields);
      setError(false);
      if (validate.status) {
        setIsProcessing(true);
        await API.post("entidades/store", {
          nombre: entidad_name,
          email: entidad_email,
          telefono: entidad_phone
        })
        .then(res => {
          if (res.data) {
            handleClose();
            getEntidades();
            showSnack('success', 'Entidad creada correctamente');
          }
          setIsProcessing(false);
        })
        .catch(err => {
          if (err.response && err.response.data && err.response.data.error) {
            showSnack('warning', err.response.data.error);
          }else{
            showSnack('warning', 'Se ha producido un error');
          }
          setIsProcessing(false);
        });
      }else{
        showSnack('warning', validate.message);
        setError(true);
      }
    }
  };

  function clearForm(){
    setEntidadId('');
    setEntidadName('');
    setEntidadEmail('');
    setEntidadPhone('');
  }

  function loadEdit(id, nombre, email, phone){
    setEntidadId(id);
    setEntidadName(nombre);
    setEntidadEmail(email);
    setEntidadPhone(phone);
    handleClickOpenEdit();
  }

  async function editEntidad(){
    if (!isProcessing) {
      var validate_fields = new Map([['nombre', entidad_name], ['email', entidad_email], ['teléfono', entidad_phone]]);
      var validate = validateFields(validate_fields);
      setError(false);
      if (validate.status) {
        setIsProcessing(true);
        await API.post(`entidades/update/${entidad_id}`, {
          nombre: entidad_name,
          email: entidad_email,
          telefono: entidad_phone
        })
        .then(res => {
          if (res.data) {
            handleClose();
            getEntidades();
            showSnack('success', 'Entidad editada correctamente');
          }
          setIsProcessing(false);
        })
        .catch(err => {
          if (err.response.data.error) {
            showSnack('warning', err.response.data.error);
          }else{
            showSnack('warning', 'Se ha producido un error');
          }
          setIsProcessing(false);
        });
      }else{
        showSnack('warning', validate.message);
        setError(true);
      }
    }
  }

  async function deleteEntidad(){
    if (!isProcessing) {
      setIsProcessing(true);
      await API.post(`entidades/destroy/${entidad_id}`)
      .then(res => {
        if (res.data) {
          handleClose();
          getEntidades();
          showSnack('success', 'Comercial eliminado correctamente');
          setIsProcessing(false);
        }
      })
      .catch(err => {
        console.log(err);
        setIsProcessing(false);
        showSnack('warning', 'Se ha producido un error, eliminando al comercial')
      });
    }
  };

  const classes = useStyles();

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="info">
            <h4 className={classes.cardTitleWhite}>Entidades</h4>
            <p className={classes.cardCategoryWhite}>
              Gestión de entidades
            </p>
          </CardHeader>
          <CardBody>
            <GridContainer direction="row"  alignItems="flex-end">
            <GridItem xs={3} sm={3} md={3}>
              <Fab style={{backgroundColor: PARAMS.firstColor, color: '#fff'}} variant="extended" onClick={() => handleClickOpen()}>
                <AddIcon />
                Crear entidad
              </Fab>
            </GridItem>
              <GridItem xs={3} sm={3} md={3} >
                <TextField
                  label="Buscar"
                  defaultValue={toSeach}
                  onChange={event => {
                    const { value } = event.target;
                    setToSearch(value);
                  }}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      event.preventDefault();
                      const { value } = event.target;
                      setToSearch(value);
                      getEntidades()
                    }
                  }}
                />
                <Fab style={{backgroundColor: PARAMS.firstColor, color: '#fff'}} variant="extended" onClick={() => getEntidades()}>
                  <SearchIcon />
                </Fab>
              </GridItem>
            </GridContainer>
            <div className={classes.root}>
              {(isLoad ?
                <>
                  <Table
                    tablePaginate={true}
                    tableHead={tableHead}
                    tableData={entidades}
                  />
                </>
              :
                <><GridContainer style={{width: '100%', height: '300px'}} direction="row"  alignItems="center" justify="center">
                    <Loader type={PARAMS.loaderType} color={PARAMS.firstColor} timeout={5000} height={100} width={100} />
                  </GridContainer>
                </>
              )}
            </div>
          </CardBody>
        </Card>
      </GridItem>
      <div>
        <Modal
          open={open}
          onCancel={() => handleClose()}
          content={formEntidades()}
          onConfirm={() => createEntidad()}
          title="Crear entidad"
        />
        <Modal
          open={openEdit}
          onCancel={() => handleClose()}
          content={formEntidades()}
          onConfirm={() => editEntidad()}
          title="Editar entidad"
        />
        <Modal
          open={openConfirm}
          onCancel={() => handleClose()}
          onConfirm={() => deleteEntidad()}
          confirmText="Confirmar"
          confirmIcon={<CheckCircleOutlineIcon style={{marginRight: '10px', color: '#fff'}} />} title="¿Seguro que deseas borrar la entidad?"  />
      </div>
    </GridContainer>
  );
}
